import React, {Component} from 'react'
import {withTranslation} from 'react-i18next';
import {Field} from 'redux-form'
import {textField} from '../Form/textField'
import {select} from '../Form/select'
import {booleanRadio} from '../Form/booleanRadio'
import {checkbox} from '../Form/checkbox'

// Decorate the class.
@withTranslation()
export default class PartialApplicant extends Component {

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;
		const personNumber = this.props.personNumber !== undefined ? this.props.personNumber : 0;

		return (
			<div className="applicant">
        {this.props.isMainApplicant === false && <h3>Zusätzliche Person {personNumber + 1}</h3>}
				<div className="row">
					<div className="col-md-4">
						<Field name={`${this.props.fieldPath}.salutation`}
						       component={select}
						       t={t}
						       options={AblCh.settings.salutation}
						       settingsName="salutation"
						       prependOptionValue=""
						       required={true}
						       prependOptionLabel={t('action.pleaseSelect')}
						       label={t('application.applicant.salutation')}/>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.firstName`}
							   component={textField}
							   required={true}
							   disabled={this.props.isMainApplicant}
							   label={t('application.applicant.firstName')}/>
					</div>
					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.lastName`}
							   component={textField}
							   required={true}
							   disabled={this.props.isMainApplicant}
							   label={t('application.applicant.lastName')}/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">

						<Field name={`${this.props.fieldPath}.address`}
							   component={textField}
							   required={true}
							   label={t('application.applicant.address')}/>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4">

						<Field name={`${this.props.fieldPath}.postalCode`}
						       component={textField}
						       required={true}
						       label={t('application.applicant.postalCode')}/>
					</div>
					<div className="col-md-8">

						<Field name={`${this.props.fieldPath}.locality`}
						       component={textField}
						       required={true}
						       label={t('application.applicant.locality')}/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-4">

						<Field name={`${this.props.fieldPath}.privatePhoneNumber`}
						       component={textField}
						       label={t('application.applicant.privatePhoneNumber')}/>

					</div>
					<div className="col-md-4">

						<Field name={`${this.props.fieldPath}.businessPhoneNumber`}
						       component={textField}
						       label={t('application.applicant.businessPhoneNumber')}/>
					</div>

					<div className="col-md-4">

						<Field name={`${this.props.fieldPath}.mobilePhoneNumber`}
						       component={textField}
						       label={t('application.applicant.mobilePhoneNumber')}/>
					</div>

          <div className="col-md-12">
            <p className="help-block">{t('application.applicant.phoneRequirementNote')}</p>
          </div>
				</div>

				<div className="row">
					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.email`}
						       component={textField}
						       required={this.props.isMainApplicant}
						       label={t('application.applicant.email')}/>
					</div>
                    {this.props.isMainApplicant &&
						<div className="col-md-6">
							&nbsp;<br />
							<Field name={`${this.props.fieldPath}.emailChangeRequest`}
								   component={checkbox}
								   label={t('application.applicant.emailChangeRequest')}/>
						</div>
                    }
				</div>

				<div className="row">
					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.birthYear`}
						       component={textField}
						       required={true}
						       label={t('application.applicant.birthYear')}/>
					</div>

					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.civilStatus`}
						       component={select}
						       t={t}
							   required={true}
						       options={AblCh.settings.civilStatus}
						       settingsName="civilStatus"
						       prependOptionValue=""
						       prependOptionLabel={t('action.pleaseSelect')}
						       label={t('application.applicant.civilStatus')}/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.occupation`}
						       component={textField}
							   required={true}
						       label={t('application.applicant.occupation')}/>
					</div>
					<div className="col-md-6">

						<Field name={`${this.props.fieldPath}.employer`}
						       component={textField}
						       label={t('application.applicant.employer')}/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">

						<Field name={`${this.props.fieldPath}.debtEnforcementMeasures`}
							   component={booleanRadio}
							   required={true}
							   labelTitle={t('application.applicant.debtEnforcementMeasures')}/>
					</div>
				</div>
			</div>
		)
	}
}
